const moment = require('moment')

export default {
  namespaced: true,
  state: {
    day1: [
      {
        thumbnail: '/img/channel08/opening.png',
        title: '朝の会だよ！みんな大集合〜！',
        description: '1日を楽しむためのスケジュールやイベント主催者を紹介☆<br>各チャンネルのおすすめプログラムや今日の楽しみ方をぎゅっとご紹介します♪',
        start: '10:00',
        end: '10:30',
        link: 'https://www.instagram.com/littlemama_official/'
      },
      {
        thumbnail: '/img/channel08/race.png',
        title: 'ハイハイ＆トイレットペーパー積みレース',
        description: 'リアルフェスタで大人気コンテンツがオンラインフェスタに登場！<br>ハイハイレースとトイレット積みレースをオンラインで開催！<br>ご自宅から参加できちゃいます☆<br>オリジナルエントリーカードに記入して参加表明だ！',
        start: '11:30',
        end: '12:00',
        link: 'https://www.instagram.com/littlemama_official/'
      },
      {
        thumbnail: '/img/channel08/aidoru.png',
        title: '～僕らの思いと魅力を電波に乗せて～アイドル候補生★アピール合戦第一弾',
        description: 'ママのための育児応援アイドルグループ誕生プロジェクト！<br>「子育てを頑張るママを応援したい！」「ママの力になりたい！」そんな思いを持ったアイドル候補生たちが登場します！<br>ダンスパフォーマンス？歌唱力？トーク力？<br>たくさん魅力をもった彼らから目が離せない！<br>詳細は近日公開！<br>公式アカウントをフォローして待っててね♪<br>＠littlemama_idol_official',
        start: '14:00',
        end: '14:30',
        link: 'https://www.instagram.com/littlemama_official/'
      },
      {
        thumbnail: '/img/channel08/ending.png',
        title: '抽選会＆最優秀コンテンツ賞発表',
        description: 'プレゼント抽選会の当選者や最優秀コンテンツ賞を発表します☆<br>みんなの今日の感想も教えてね(^^♪',
        start: '15:50',
        end: '16:10',
        link: 'https://www.instagram.com/littlemama_official/'
      }
    ],
    day2: [
      {
        thumbnail: '/img/channel08/opening.png',
        title: '朝の会だよ！みんな大集合〜！',
        description: '1日を楽しむためのスケジュールやイベント主催者を紹介☆<br>各チャンネルのおすすめプログラムや今日の楽しみ方をぎゅっとご紹介します♪',
        start: '10:00',
        end: '10:30',
        link: 'https://www.instagram.com/littlemama_official/'
      },
      {
        thumbnail: '/img/channel08/bday.png',
        title: '8月生まれの誕生日お祝い会',
        description: '8月生まれのご家族がいるママたち集まれ～～～！<br>毎月恒例になったお誕生日会！8月生まれの皆さんお待たせしました☆<br>みんなで誕生日をお祝いしましょう♪同じ誕生日の人にも出会えるかも？！',
        start: '11:30',
        end: '12:00',
        link: 'https://www.instagram.com/littlemama_official/'
      },
      {
        thumbnail: '/img/channel08/aidoru.png',
        title: '～僕らの思いと魅力を電波に乗せて～アイドル候補生★アピール合戦第一弾',
        description: 'ママのための育児応援アイドルグループ誕生プロジェクト！<br>「子育てを頑張るママを応援したい！」「ママの力になりたい！」そんな思いを持ったアイドル候補生たちが登場します！<br>ダンスパフォーマンス？歌唱力？トーク力？<br>たくさん魅力をもった彼らから目が離せない！<br>詳細は近日公開！<br>公式アカウントをフォローして待っててね♪<br>＠littlemama_idol_official',
        start: '13:00',
        end: '13:30',
        link: 'https://www.instagram.com/littlemama_official/'
      },
      {
        thumbnail: '/img/channel08/game.png',
        title: '東西対決！ジェスチャーゲーム',
        description: '東日本ママVS西日本ママの対決第2弾！<br>第2弾はジェスチャーゲーム！リトル・ママスタッフが何をしているか当ててね！<br>制限時間にどちらのチームが多く正解できるかな？？',
        start: '14:00',
        end: '14:30',
        link: 'https://www.instagram.com/littlemama_official/'
      },
      {
        thumbnail: '/img/channel08/ending.png',
        title: '抽選会＆最優秀コンテンツ賞発表',
        description: 'プレゼント抽選会の当選者や最優秀コンテンツ賞を発表します☆<br>みんなの今日の感想も教えてね(^^♪',
        start: '15:50',
        end: '16:10',
        link: 'https://www.instagram.com/littlemama_official/'
      }
    ]
  },
  mutations: {},
  actions: {},
  getters: {
    onair: state => {
      const date = moment()
      let programs = []
      if (date.isSame('2020-08-27', 'day')) {
        programs = state.day1.filter((program) => {
          return date.isBetween('2020-08-27 ' + program.start, '2020-08-27 ' + program.end, 'minute', '[]')
        })
      } else if (date.isSame('2020-08-28', 'day')) {
        programs = state.day2.filter((program) => {
          return date.isBetween('2020-08-28 ' + program.start, '2020-08-28 ' + program.end, 'minute', '[]')
        })
      }
      return programs[0]
    },
    next: state => {
      const date = moment()
      let programs = []
      if (date.isSame('2020-08-27', 'day')) {
        programs = state.day1.filter((program) => {
          return date.isBefore('2020-08-27 ' + program.start)
        })
      } else if (date.isSame('2020-08-28', 'day')) {
        programs = state.day2.filter((program) => {
          return date.isBefore('2020-08-28 ' + program.start)
        })
      }
      return programs[0]
    }
  }
}
